module.exports = __webpack_public_path__ + "9cf98f3da284268ecd8d48cdb11b829b.pdf";